export const logo = require('../assets/images/aa-logo.svg');
export const generalErrorImage = require('../assets/images/general_error_image.svg');
export const arrowUp = require('../assets/images/arrow_up.svg');
export const arrowDown = require('../assets/images/arrow_down.svg');
export const BadRequestErrorImage = require('../assets/images/bad_request_error.svg');
export const CheckoutAnimation = require('../assets/images/checkout_animation.gif');
export const MemberGold = require('../assets/images/member_gold.svg');
export const MemberBlack = require('../assets/images/member_black.svg');
export const MemberPlatinum = require('../assets/images/member_platinum.svg');
export const MemberRed = require('../assets/images/member_red.svg');
export const ChangeCurrency = require('../assets/images/change_currency.svg');
export const ApiFail = require('../assets/images/api_fail.png');
export const HotelNotAvailableAnymore = require('../assets/images/hotel_not_available_anymore.png');
export const FlightNotAvailableAnymore = require('../assets/images/flight_not_available_anymore.png');
export const PriceChanged = require('../assets/images/price_changed.png');
export const BigPoint = require('../assets/images/big_points.svg');
export const HotelImageHolder = require('../assets/images/hotel_image_holder.svg');
export const Flights = require('../assets/images/flights.svg');
export const PaymentDiscountIcon = require('../assets/images/payment_discount.svg');
export const EmptyRoomAvailabilityImage = require('../assets/images/empty_room_availability_image.svg');
export const CloseIcon = require('../assets/images/close_icon.svg');
export const HotelCheckinIcon = require('../assets/images/hotel_checkin_icon.svg');
export const HotelCheckoutIcon = require('../assets/images/hotel_checkout_icon.svg');
export const AdultIcon = require('../assets/images/adult_icon.svg');
export const ChildIcon = require('../assets/images/child_icon.svg');
export const InfantIcon = require('../assets/images/infant_icon.svg');
export const BookingExistedImage = require('../assets/images/booking-existed.png');
export const BookingIncorrectNameImage = require('../assets/images/booking-incorrect-name.png');
export const BookingSoldOut = require('../assets/images/booking-sold-out.png');
export const ExpandIcon = require('../assets/images/expand.svg');
export const ToolTipIcon = require('../assets/images/tool_tip_icon.svg');
export const ArrowUpIcon = require('../assets/images/up_arrow_icon.svg');
export const ArrowDownIcon = require('../assets/images/down_arrow_icon.svg');
